import dayjs from 'dayjs';
import { Ga4PageView } from '@models/ga4';
import {
  getCookieChannelId,
  getCookieCustno,
  getCookieWckAuthData,
} from '@wconcept/wconcept-common/utils/cookie';

const GENDER_MALE = '01';
const GENDER_FEMALE = '02';
const AUTHORIZED = 'Y';
const UNAUTHORIZED = 'N';
const UNKNOWN = 'U';

// 도우미 함수
function formatBirth(birth: string | undefined): string {
  return birth ? dayjs(birth).format('YYYY') : UNKNOWN;
}

function formatJoinDate(joinDate: string | undefined): string {
  return joinDate ? dayjs(joinDate).format('YYYYMM') : '';
}

function formatLastLoginDate(lastLoginDate: string | undefined): string {
  return lastLoginDate ? dayjs(lastLoginDate).format('YYYYMMDD') : '';
}

function formatGender(gender: string | undefined): string {
  if (!gender) return UNKNOWN;
  return gender === GENDER_MALE ? 'M' : 'F';
}

function formatAuthorization(isCert: boolean): string {
  return isCert ? AUTHORIZED : UNAUTHORIZED;
}

function formatPushYN(pushYN: string): string {
  return pushYN === 'A' ? AUTHORIZED : UNAUTHORIZED;
}

function removeEmptyStringProperties(property: Ga4PageView): Ga4PageView {
  const result = { ...property };
  (Object.keys(result) as (keyof Ga4PageView)[]).forEach(key => {
    if (result[key] === '') {
      delete result[key];
    }
  });
  return result;
}
const getTypeName = (type: string) => {
  let typeName = '';
  switch (type) {
    case 'C':
      typeName = '일반';
      break;
    case 'kk':
      typeName = '카카오';
      break;
    case 'gg':
      typeName = '구글';
      break;
    case 'fb':
      typeName = '페이스북';
      break;
    case 'nv':
      typeName = '네이버';
      break;
    case 'ig':
      typeName = '인스타그램';
      break;
    case 'ap':
      typeName = '애플';
      break;
    default:
      typeName = '';
  }

  return typeName;
};

const getGa4UserProperty = async (pageObj: Ga4PageView) => {
  const custInfo = await getCookieWckAuthData();
  const channelId = await getCookieChannelId();

  // 개선된 userProperty 정의
  const userProperty: Ga4PageView = {
    up_custNo: custInfo.userNo,
    up_authorizeYN: formatAuthorization(custInfo.isCert),
    up_gender: formatGender(custInfo.gender),
    up_birth: formatBirth(custInfo.birth),
    up_signUpDate: formatJoinDate(custInfo.joinDate),
    up_lastLoginDate: formatLastLoginDate(custInfo.lastLoginDate),
    up_snsType: getTypeName(custInfo.snsType),
    up_degree: custInfo.grade,
    up_loginType: getTypeName(custInfo.loginType),
    up_apppushYN: formatPushYN(custInfo.pushYN),
    up_smsYN: custInfo.smsYN,
    up_emailYN: custInfo.emailYN,
    up_channelid: channelId,
    up_kakaotalkYN: custInfo.kakaotalkYN,
    title: pageObj.title,
    location: pageObj.location,
    ep_visit_device: pageObj.ep_visit_device,
    ep_visit_domainGender: pageObj.ep_visit_domainGender,
    ep_page_searchKeyword: pageObj.ep_page_searchKeyword,
    ep_page_searchType: pageObj.ep_page_searchType,
    ep_page_brandCD: pageObj.ep_page_brandCD,
    ep_page_issueCD: pageObj.ep_page_issueCD,
    ep_page_itemCD: pageObj.ep_page_itemCD,
    ep_page_itemNM: pageObj.ep_page_itemNM,
    ep_page_issueNM: pageObj.ep_page_issueNM,
    ep_page_brandNM: pageObj.ep_page_brandNM,
    ep_page_lookbookCD: pageObj.ep_page_lookbookCD,
    ep_page_tagExclusive: pageObj.ep_page_tagExclusive,
    ep_page_searchResult: pageObj.ep_page_searchResult,
    ep_page_profileCD: pageObj.ep_page_profileCD,
    ep_page_creatorYN: pageObj.ep_page_creatorYN,
    ep_page_itemList: pageObj.ep_page_itemList,
  };
  if (custInfo.userNo === '0') {
    // 비로그인시 해당 속성 삭제
    delete userProperty.up_authorizeYN;
    delete userProperty.up_gender;
    delete userProperty.up_birth;
    delete userProperty.up_signUpDate;
    delete userProperty.up_lastLoginDate;
    delete userProperty.up_snsType;
    delete userProperty.up_degree;
    delete userProperty.up_loginType;
    delete userProperty.up_apppushYN;
    delete userProperty.up_smsYN;
    delete userProperty.up_emailYN;
    delete userProperty.up_kakaotalkYN;
  }

  return removeEmptyStringProperties(userProperty);
};

export default getGa4UserProperty;
